import { render, staticRenderFns } from "./NewScratchCustomer.vue?vue&type=template&id=7d170b1e&scoped=true&lang=pug&"
import script from "./NewScratchCustomer.vue?vue&type=script&lang=js&"
export * from "./NewScratchCustomer.vue?vue&type=script&lang=js&"
import style0 from "./NewScratchCustomer.vue?vue&type=style&index=0&id=7d170b1e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d170b1e",
  null
  
)

export default component.exports